import log from 'salvo-lite/log'
import Colcade from 'colcade'

class Masonry {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (window.innerWidth > 768) {
            const colc = new Colcade(this._elem, {
                columns: '.grid-col',
                items: '.grid-item'
            })
            document.addEventListener('masonry-update', e => {
                colc.append(e.detail)
            })
        }
    }
}

export default Masonry



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Masonry.js